import * as ActionTypes from "../action-types/tripRecord";

const tripRecordStore = {
    byVID: {},
    byTrID: {},
    formattedData: {},

    selectedDate: "",
    selectedIndex: 0,

    selectedTrID: "",
};

export const tripRecord = (state = tripRecordStore, action) => {
    const newStore = JSON.parse(JSON.stringify(state))

    switch (action.type) {
        case ActionTypes.GET_TRIP_RECORD: {
            // console.log("Trip Record Data", action.tripRecord);

            // Always reset byVID and byTrID array obj when getting data
            newStore.byVID = {};
            newStore.byTrID = {};

            // let fuel_total = 0;

            // console.log("tripRecord", action)

            action.tripRecord.forEach((currTrip) => {
                newStore.byTrID[currTrip.trid] = currTrip;

                // Define this VID key as an empty array first
                if (!newStore.byVID[currTrip.vid]) {
                    newStore.byVID[currTrip.vid] = [];
                }

                newStore.byVID[currTrip.vid].push(currTrip);
            })

            newStore.formattedData = action.formattedData
            // console.log("Trip Record Fuel Total:", fuel_total);

            return newStore;
        }

        case ActionTypes.SET_TRIP_RECORD_SELECTED_TRID: {
            // console.log("New Trip Record Selected TrID:", action.selectedTrID);

            newStore.selectedTrID = action.selectedTrID;

            return newStore;
        }

        case ActionTypes.CLEAR_TRIP_RECORD_SELECTED_TRID: {
            // console.log("Clear Trip Record Selected TrID");

            newStore.selectedTrID = null;

            return newStore;
        }

        case ActionTypes.SET_TRIP_RECORD_SELECTED_DATE_AND_INDEX: {
            // console.log("New Trip Record Selected Date:", action.selectedDate);

            newStore.selectedDate = action.selectedDate;
            newStore.selectedIndex = action.selectedIndex;

            return newStore;
        }

        case ActionTypes.CLEAR_TRIP_RECORD_SELECTED_DATE_AND_INDEX: {
            // console.log("Clear Trip Record Selected Date");

            newStore.selectedDate = newStore.selectedIndex = null;

            return newStore;
        }
        default: {
            return state;
        }
    }
}